<div class="flex flex-column">

  <div class="mt-6 mb-7 text-center">
    <p class="text-4xl">
      {{ 'misc.welcomeUser' | transloco: ({username: user.given_name ?? user.username}) }}
    </p>
  </div>

  <div *ngIf="tenantUuid === 'f89012f8-150c-4adc-b829-a24e0df1efc9'" class="flex justify-content-evenly pb-5">
    <img src="assets/logo-eu.png" alt="Financiado por la Unión Europea" width="230" height="60" priority>
    <img src="assets/logo-gob.png" alt="Gobierno de España" width="300" height="75" priority>
    <img src="assets/logo-prtr.png" alt="Plan de Recuperación, Transformación y Resiliencia" width="295" height="55" priority>
  </div>

  <div class="grid">
    <div [class]="item.items ? 'col-12' : 'col-12 xl:col-6 xxl:col-4 p-3'" *ngFor="let item of items">

      <ng-container
        *ngIf="!item.items"
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ item: item }"
      ></ng-container>

      <div *ngIf="item.items" class="grid">
        <div [id]="item.routerLink" class="col-12 pb-3 pt-6 text-center">
          <hr class="section-hr">
          <p class="text-2xl relative" style="top: -30px; left: calc(50% - 90px); background: #EBEBEB; width: 180px;">
            <i [class]="item.icon" style="font-size: 16px; margin-right: 6px;"></i>
            {{item.label | transloco}}
          </p>
        </div>
        <div class="col-12 xl:col-6 xxl:col-4 p-3" *ngFor="let subItem of item.items">
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ item: subItem }"
          ></ng-container>
        </div>
      </div>

    </div>
  </div>
</div>
<ng-template let-item="item" #itemTemplate>
  <div class="card landing-card" [routerLink]="item.routerLink">
    <p class="landing-card-title text-2xl md:text-4xl">
      <i *ngIf="item.icon" class="{{item.icon}} landing-card-icon text-2xl md:text-4xl mr-2"></i>
      {{item.label | transloco}}
    </p>
    <p class="landing-card-description">
      {{item.description | transloco}}
    </p>
  </div>
</ng-template>
